import Header from './modules/header'
import Locator from './modules/locator'
import Fancybox from '@fancyapps/fancybox'
import { Mobile, Tabs, Popup, TRANSITION_END, getCookie, setCookie, Carousel_CoreInit, Scrollbar } from './core'
import './plugins/forms'
import './plugins/slide-selector-menu'
import './plugins/scroll-to-anchor'
import './plugins/stick-to-container'
import './plugins/ajax-post-toolbar'
import './plugins/project-gallery'
import './plugins/compare-row'
import './plugins/stairs-effect'
import './plugins/tabs'
import './plugins/extending-list'
import './plugins/grid-overlap'
import './plugins/parallax'
import './plugins/section-popup'
import './plugins/video-autoplay'
import './plugins/google-map'

Carousel_CoreInit([
  {
    classSelector: 'carousel--style--realisations',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          loopFillGroupWithBlank: true,
          spaceBetween: 10,
        },
      },
      pagination: {
        el: '.carousel--style--realisations__progress-bar',
        type: 'progressbar',
      },
    },
    carouselOptions: {
      forceRebuild: true,
    }
  },
  {
    classSelector: 'carousel--style--feature',
    swiperOptions: {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        renderBullet: function(index, className) {
          index = (index < 9) ? '0' + (index + 1) : index + 1
          return '<span class="' + className + '">' + index + '</span>'
        },
      },
      on: {
        beforeInit: function(swiper) {
          swiper.$el.find('.card-feature').each(function(el, index) {
            let $image = $(el).find('.picture').clone().attr('data-index', index).attr('aria-hidden', index ? 'true' : 'false')
            $image.appendTo(swiper.$el.closest('.feature').find('.feature__image'))
          })
          swiper._mlmi_activeIndexChange = function(swiper) {
            if (swiper.previousRealIndex != undefined && swiper.previousRealIndex != swiper.realIndex) {
              swiper.previousRealIndex = swiper.realIndex
              swiper.$el.closest('.feature').find('.feature__image .picture[aria-hidden="false"]').attr('aria-hidden', 'true')
              swiper.$el.closest('.feature').find('.feature__image .picture[data-index="' + swiper.realIndex + '"]').attr('aria-hidden', 'false')
            }
          }
        },
        init: function(swiper) {
          swiper.previousRealIndex = -1
          swiper._mlmi_activeIndexChange(swiper)
        },
        activeIndexChange: function(swiper) {
          swiper._mlmi_activeIndexChange(swiper)
        },
      },
    },
  },
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroll: $(window).ScrollEvents(),
  }

  /* Header */
  Header.init()

  /* Locator */
  Locator.init()

  /* Popup */
  Popup.init()

  /* Job offers */
  $('.js-extending-list').each(function() {
    $(this).ExtendingList()
  })

  /* Contact map */
  $('.contact-map').each(function() {
    $(this).ContactMap()
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  $('.contact-form').each(function() {
    $(this).ContactForm()
  })

  $('.application-form').each(function() {
    $(this).ApplicationForm()
  })

  $('.quote-form').each(function() {
    $(this).QuoteForm()
  })

  $('.quote-short-form').each(function() {
    $(this).QuoteShortForm()
  })

  $('.retailer-form').each(function() {
    $(this).RetailerForm()
  })

  $('.call-back-form').each(function() {
    $(this).CallBackForm()
  })

  $('.quick-lead-form').each(function() {
    $(this).QuickLeadForm()
  })

  $('.select__options').each(function() {
    new Scrollbar($(this))
  })

  $('.video-autoplay').each(function() {
    $(this).VideoAutoplay();
  })

  /* Contact map */
  $('.header__main-menu .main-menu, .header__sub-menu .main-menu').each(function() {
    $(this).slideSelectorMenu()
  })

  $('.images-layout-row .images-layout__item:last-child .picture').each(function() {
    $(this).parallax(-.4, 'desktop')
    $(this).parallax(-.2, 'mobile')
  })

  $('.custom-layout .--image-2 .picture').each(function() {
    $(this).parallax(-.2)
  })

  $('.custom-layout .--image-1 .picture').each(function() {
    $(this).parallax(.1)
  })

  $('.text-row .images-layout__item:last-child .picture').each(function() {
    $(this).parallax(-.2)
  })

  /* Create a menu out of titles in content */
  $('.table-of-contents a').each(function() {
    $(this).scrollToAnchor();
  })

  /* Make anchor menu stick to the left when we scroll */
  $('.js-anchor-menu').each(function() {
    $(this).stickToContainer('.js-anchor-menu-container', $('header').height() + 60);
  })

  /* Enable post toolbar */
  $('.ajax-post-toolbar').each(function() {
    $(this).ajaxPostToolbar('.ajax-post-toolbar-results', '.ajax-post-toolbar-load-more');
  })

  /* Gallery on Project page */
  $('.js-project-gallery-wrapper').each(function() {
    $(this).projectGallery();
  })

  $('.grid-overlap').each(function() {
    $(this).gridOverlap()
  })

  $('*[class^="btn-primary"], *[class*=" btn-primary"], *[class^="btn-secondary"], *[class*=" btn-secondary"]').each(function() {
    $(this).wrapInner( "<span></span>");
  })


  /* Fancybox */
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons: ['close'],
    transitionEffect: 'slide',
    backFocus: false,
    i18n: {
      fr: {
        CLOSE: "Fermer",
        NEXT: "Photo suivante",
        PREV: "Photo précédente",
      },
    },
    lang: 'fr',
  })

  $('.grid').each(function(index) {
    $(this).find('.fancybox-trigger').attr('data-fancybox', 'grid_gallery_' + index)
  })

  /* Tabs */
  $('.tabs.tabs--bottom-navigation').each(function() {
    $(this).navigationAfterContent();
  });
  Tabs.init() // after navigationAfterContent

  /* Clic anchor */
  $('main a[href^="#"]').on('click', function() {
    if ($('a[name="' + $(this).attr('href').substring(1) + '"]').length) {
      let targetTop = $('a[name="' + $(this).attr('href').substring(1) + '"]').offset().top
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false
    } else if ($($(this).attr('href')).length) {
      let targetTop = $($(this).attr('href')).offset().top - $('.header').outerHeight(false) - 32
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false
    }
  })

  /* Search */
  $('input[name="s"]').on('focus', function() {
    let searchField = $(this)
    setTimeout(function() {
      searchField.get(0).select()
    }, 25)
  })

  /* Animate compare row table */
  $(':not(.compare-row) + .compare-row, * > .compare-row:first-of-type').each(function() {
    $(this).nextUntil(':not(.compare-row)').addBack().wrapAll('<div class="js-compare container" />');
  });

  $('.js-compare').each(function() {
    $(this).compareRow('.compare-row', '.js-compare__sticky-content');
  });

  /* Stairs Effect on multiple columns */
  $('.row.stairs-effect').each(function() {
    $(this).stairsEffect();
  });

  /* make videos look like images */
  $('.video-loop').each(function() {
    let self = $(this)
    let video = $(this).find('video')
    if (video.data('loaded')) {
      setTimeout(function() {
        picture(video.get(0))
        video.get(0).play()
      }, 60)
    } else {
      video.on('canplaythrough', function() {
        picture(video.get(0))
        video.get(0).play()
      })
    }
  })

  /* Media Gallery */
  $('.image-gallery').each(function(index) {
    $(this).find('[data-fancybox="gallery"]').attr('data-fancybox', 'gallery_' + index);
    $('[data-fancybox="gallery_' + index + '"]').fancybox({
      loop: true,
      openEffect: 'elastic',
      closeEffect: 'elastic',
      nextEffect: 'fade',
      prevEffect: 'fade',
      mainClass: '--image-gallery'
    });
  })

  /* carousel */
  $('.carousel--custom.carousel--style--default .carousel').each(function() {
    var data_carousel = $(this).attr('data-carousel');
    if (data_carousel != undefined && data_carousel.includes("use_arrows") && data_carousel.includes("use_scrollbar")) {
      $(this).addClass('--arrows-overlapping');
      $(this).closest('div[class^=container]').attr('class', 'container-full');
      $(this).css('--arrows-top', $(this).find('.card-custom__image').first().height() + 'px')
    }
  })
  $('.carousel--custom.carousel--style--default .carousel').each(function() {
    var data_carousel = $(this).attr('data-carousel');
    if (data_carousel != undefined && data_carousel.includes("use_arrows") && !data_carousel.includes("use_scrollbar")) {
      $(this).addClass('--arrows-to-left');
      $(this).css('--arrows-top', $(this).find('.card-custom__image').first().height() + 'px')
    }
  })

  /* Carousel hint animation */
  $('.carousel.swiper-initialized:not(.carousel--style--realisations > .carousel):not(.carousel--style--feature > .carousel)').each(function() {
    let carousel = $(this).data('carousel')
    if (carousel != undefined) {
      carousel.unhintAnimation = function() {
        carousel.find('.swiper-slide').off(TRANSITION_END, carousel.unhintAnimation)
        carousel.find('.swiper-slide').removeClass('swiper-slide--hint')
        carousel.find('.swiper-scrollbar').removeClass('swiper-scrollbar--hint')
      }
      carousel.hintAnimation = function() {
        carousel.find('.swiper-slide').addClass('swiper-slide--hint').on(TRANSITION_END, carousel.unhintAnimation)
        carousel.find('.swiper-scrollbar').addClass('swiper-scrollbar--hint')
        carousel.hintTimeout = setTimeout(carousel.hintAnimation, 12500)
      }
      carousel.firstMove = function() {
        clearTimeout(carousel.hintTimeout)
        carousel.swiper.off('sliderFirstMove', carousel.firstMove)
        carousel.find('.swiper-slide').off(TRANSITION_END, carousel.unhintAnimation)
        carousel.find('.swiper-slide').removeClass('swiper-slide--hint')
        carousel.find('.swiper-scrollbar').removeClass('swiper-scrollbar--hint')
      }
      carousel.inViewCheck = function(top) {
        let targetY = carousel.offset().top + (carousel.outerHeight(false) / 1.5) - top - $(window).height()
        if (targetY < 0) {
          $.mlmi.scroll.removeCallback(carousel.inViewCheck)
          carousel.swiper.on('sliderFirstMove', carousel.firstMove)
          carousel.hintTimeout = setTimeout(carousel.hintAnimation, 3250)
        }
      }
      $.mlmi.scroll.add(carousel.inViewCheck)
    }
  })

  /* Close popup */
  if (getCookie('popup-displayed') != 'yes') {
    setCookie('popup-displayed', 'yes', 60*60*24)
    $('.popup').each(function() {
      let $popup = $(this)
      $popup.attr('aria-hidden', 'false')
      $popup.find('.popup__close').on('click', function() {
        $popup.attr('aria-hidden', 'true')
      })
    })
  }

  $('.section-popup').each(function() {
    $(this).SectionPopup()
  })
})

$(window).on('resize load orientationchange', function() {
  $('body').css('--body-width', document.body.clientWidth + 'px');
})

// $(window).on('resize load orientationchange', function() {
//   $('.carousel--custom .carousel.--arrows-to-left, .carousel--custom .carousel.--arrows-overlapping').each(function() {
//     $(this).css('--arrows-top', $(this).find('.card-custom__image').first().height() + 'px')
//   })
// })
